import React from "react";
import { Table } from "react-bootstrap";
import { fetchBlogsAdmin, deleteBlog } from "../../actions/blogActions";
import { connect } from "react-redux";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import NavbarClass from "../NavbarClass";
import { Form as ReactFinalForm, Field } from "react-final-form";
import _, { findLastKey } from "lodash";
import { localAPI } from "../../api/local";
import { Redirect } from "react-router-dom";
import AdminBlogEntry from "./AdminBlogEntry";
import history from "../../config/history";
import { Helmet } from "react-helmet";


export class AdminBlogPage extends React.Component {
  async componentDidMount() {
    await this.props.fetchBlogsAdmin();
    await localAPI
      .get("/api/users/isadmin")
      .then((data) => {
        if (!data.data.success) this.setState({ isAdmin: false });
      })
      .catch((err) => {
        this.setState({ isAdmin: false });
      });
  }

  state = {
    deleteModalShow: false,
    editAddModalShow: false,
    editModalShow: false,
    blogToDelete: {},
    isAdmin: true,
    blogToEdit: {},
  };

  handleDeleteModalClose = () => {
    this.setState({ deleteModalShow: false, blogToDelete: {} });
  };
  handleDeleteModalShow = (blog) =>
    this.setState({ deleteModalShow: true, blogToDelete: blog });
  handleEditAddModalClose = () => {
    this.setState({ editAddModalShow: false });
  };
  handleEditAddModalShow = (blog) =>
    this.setState({ editAddModalShow: true, blogToEdit: blog });

  renderTable = () => {
    return this.props.blogs.map((blog, key) => {
      return (
        <tr
          key={key + 1}
          style={
            blog.hideBlog ? { background: "rgba(128, 128, 128, 0.2)" } : {}
          }
        >
          <td>{key + 1}</td>
          <td>
            <img
              style={{ maxWidth: "100px" }}
              src={blog.thumbnailLink}
              alt={`thumbnail for ${blog.title}`}
              width="1200"
              height="700"
            />
          </td>
          <td>{blog._id}</td>
          <td>{blog.title}</td>
          <td>{blog.isFreeBlog ? "Yes" : "No"}</td>
          <td>som link</td>
          <td>{blog.category}</td>
          <td>
            {new Date(blog.uploadDateTime).toLocaleString("hi-IN", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </td>
          <td>
            <div
              className="btn btn-warning"
              onClick={() => this.handleEditAddModalShow(blog)}
            >
              Edit
            </div>
            <div
              className="btn btn-danger"
              onClick={() => this.handleDeleteModalShow(blog)}
            >
              Delete
            </div>
          </td>
        </tr>
      );
    });
  };

  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {this.state.isAdmin ? (
          <div>
            <Modal
              show={this.state.deleteModalShow}
              onHide={this.handleDeleteModalClose}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Blog?</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <p>Do you want to delete this blog?</p>
                <Table>
                  <thead>
                    <tr>
                      <th>Thumbnail</th>
                      <th>id</th>
                      <th>Title</th>
                      <th>Free</th>
                      <th>Upload Date</th>
                    </tr>
                    <tr>
                      <td>
                        {
                          <img
                            alt={`thumbnail for ${this.state.blogToDelete.title}`}
                            src={this.state.blogToDelete.thumbnailLink}
                            style={{ maxWidth: "100px" }}
                            width="1200"
                            height="700"
                          />
                        }
                      </td>
                      <td>{this.state.blogToDelete._id}</td>
                      <td>{this.state.blogToDelete.title}</td>
                      <td>
                        {this.state.blogToDelete.isFreeBlog ? "Yes" : "No"}
                      </td>
                      <td>
                        {new Date(
                          this.state.blogToDelete.uploadDateTime
                        ).toLocaleString("hi-IN", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })}
                      </td>
                    </tr>
                  </thead>
                </Table>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary">No</Button>
                <Button
                  variant="danger"
                  onClick={async () =>
                    await this.props.deleteBlog(this.state.blogToDelete._id)
                  }
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.editAddModalShow}
              onHide={this.handleEditAddModalClose}
              fullscreen={true}
            >
              <Modal.Header closeButton>
                <Modal.Title>Add Blog</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <AdminBlogEntry blogToEdit={this.state.blogToEdit} />
              </Modal.Body>
            </Modal>

            <button
              className="btn btn-primary"
              onClick={() => this.handleEditAddModalShow()}
            >
              Add Blog
            </button>

            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Thumbnail</th>
                  <th>id</th>
                  <th>Title</th>
                  <th>Free</th>
                  <th>VideoLink</th>
                  <th>Category</th>
                  <th>Upload Date</th>
                  <th>Options</th>
                </tr>
                {this.props.blogs ? this.renderTable() : "loading"}
              </thead>
            </Table>
          </div>
        ) : (
          <Redirect to="/" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blogs: state.blogs.blogs?.blogs,
    error: state.blogs.error,
  };
};

export default connect(mapStateToProps, { fetchBlogsAdmin, deleteBlog })(
  AdminBlogPage
);
